import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ClientAdjustedGrossRevenue extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Client Adjusted Gross Revenue'
          reportParams={reportParams}
          id='clientadjustedgrossrevenue'
          name='clientadjustedgrossrevenue'
          title='Client Adjusted Gross Revenue - BETA'
        />
      </div>
    );
  }
}
